import { Wrench, Zap, Hammer, Layers, Paintbrush, LayoutGrid, ShieldCheck } from "lucide-react";

export const TRADES = [
  { id: "fontaneria", name: "Fontanería", desc: "Fugas, termos, desatascos e instalaciones de agua", icon: Wrench, chip: "bg-sky-50 text-sky-700 border-sky-200", tile: "bg-sky-50 text-sky-600" },
  { id: "electricidad", name: "Electricidad", desc: "Cuadros, boletines, iluminación y averías", icon: Zap, chip: "bg-amber-50 text-amber-700 border-amber-200", tile: "bg-amber-50 text-amber-600" },
  { id: "manitas", name: "Manitas", desc: "Montaje de muebles, colgar TV, persianas y arreglos", icon: Hammer, chip: "bg-rose-50 text-rose-700 border-rose-200", tile: "bg-rose-50 text-rose-600" },
  { id: "carpinteria", name: "Carpintería", desc: "Puertas, armarios a medida y madera", icon: Layers, chip: "bg-orange-50 text-orange-700 border-orange-200", tile: "bg-orange-50 text-orange-600" },
  { id: "pintura", name: "Pintura", desc: "Pisos, quitar gotelé, alisados y humedades", icon: Paintbrush, chip: "bg-violet-50 text-violet-700 border-violet-200", tile: "bg-violet-50 text-violet-600" },
  { id: "suelos", name: "Suelos", desc: "Tarima, parquet, microcemento y alicatado", icon: LayoutGrid, chip: "bg-emerald-50 text-emerald-700 border-emerald-200", tile: "bg-emerald-50 text-emerald-600" },
  { id: "mantenimiento", name: "Mantenimiento", desc: "Mantenimiento preventivo de viviendas y locales", icon: ShieldCheck, chip: "bg-teal-50 text-teal-700 border-teal-200", tile: "bg-teal-50 text-teal-600" },
];
export const TRADE_MAP = Object.fromEntries(TRADES.map((t) => [t.id, t]));
export const tradeName = (id) => TRADE_MAP[id]?.name ?? id;

export const STATUS = {
  abierto: { label: "Recibiendo presupuestos", cls: "bg-sky-100 text-sky-800" },
  solicitado: { label: "Pendiente de respuesta", cls: "bg-amber-100 text-amber-900" },
  asignado: { label: "Asignado", cls: "bg-indigo-100 text-indigo-800" },
  en_curso: { label: "En curso", cls: "bg-orange-100 text-orange-800" },
  completado: { label: "Completado", cls: "bg-emerald-100 text-emerald-800" },
  facturado: { label: "Facturado · pendiente de pago", cls: "bg-violet-100 text-violet-800" },
  pagado: { label: "Pagado", cls: "bg-emerald-600 text-white" },
  cancelado: { label: "Cancelado", cls: "bg-slate-200 text-slate-700" },
  rechazado: { label: "Rechazado", cls: "bg-rose-100 text-rose-800" },
};

export const CHECKLIST = [
  { id: "finish_quality", label: "Calidad del acabado y estética del trabajo", weight: 25 },
  { id: "technical_verification", label: "Comprobación técnica in situ (sin fugas, todo funciona)", weight: 25 },
  { id: "cleanliness", label: "Limpieza y recogida de restos en la zona de trabajo", weight: 20 },
  { id: "punctuality", label: "Puntualidad y cumplimiento del plazo acordado", weight: 15 },
  { id: "professional_treatment", label: "Trato profesional y explicaciones claras", weight: 15 },
];

export const INCIDENT_CATS = ["Trabajo incompleto", "Desperfecto o daño colateral", "Discrepancia en cobro", "Garantía de reparación"];
export const CITIES = ["Madrid", "Barcelona", "Valencia", "Sevilla", "Zaragoza", "Málaga", "Bilbao", "Alicante"];

export const CONTACT = {
  phone: "+34900839240",
  phoneDisplay: "900 839 240",
  whatsappDisplay: "+34 611 839 240",
  whatsappUrl: "https://wa.me/34611839240?text=Hola%2C%20necesito%20asistencia%20en%20HandyZoom",
  email: "soporte@handyzoom.es",
  hours: "7 días · 8:00–22:00",
};

export const DEMO_ACCOUNTS = [
  { id: "cliente", label: "Cliente · Laura Gómez", email: "cliente@oficiosya.es", password: "Cliente123!" },
  { id: "pro", label: "Carlos Ruiz (Fontanero)", email: "carlos@oficiosya.es", password: "Pro123!" },
  { id: "pro-elec", label: "Elena Navarro (Electricista)", email: "elena@oficiosya.es", password: "Pro123!" },
];

const EUR = new Intl.NumberFormat("es-ES", { style: "currency", currency: "EUR" });
export const eur = (v) => (v == null ? "—" : EUR.format(v));
export const fdate = (v) => (v ? new Date(v).toLocaleDateString("es-ES", { day: "2-digit", month: "2-digit", year: "numeric" }) : "—");
export const fdatetime = (v) => new Date(v).toLocaleString("es-ES", { day: "2-digit", month: "short", hour: "2-digit", minute: "2-digit" });
export const initials = (n = "") => n.split(" ").map((p) => p[0]).slice(0, 2).join("").toUpperCase();

export const IMG_HERO = "https://images.unsplash.com/photo-1676210134188-4c05dd172f89?crop=entropy&cs=srgb&fm=jpg&q=80&w=1200";
export const IMG_TRAINING = "https://images.unsplash.com/photo-1505798577917-a65157d3320a?crop=entropy&cs=srgb&fm=jpg&q=80&w=1000";

export const APPT_STATUS = {
  pendiente: { label: "Pendiente de confirmar", cls: "bg-amber-100 text-amber-900", dot: "bg-amber-500" },
  propuesta: { label: "Nuevo horario propuesto", cls: "bg-sky-100 text-sky-800", dot: "bg-sky-500" },
  confirmada: { label: "Confirmada", cls: "bg-emerald-100 text-emerald-800", dot: "bg-emerald-500" },
  cancelada: { label: "Cancelada", cls: "bg-slate-200 text-slate-700", dot: "bg-slate-400" },
};
export const WEEKDAYS_SHORT = ["Lun", "Mar", "Mié", "Jue", "Vie", "Sáb", "Dom"];
export const WEEKDAYS = ["Lunes", "Martes", "Miércoles", "Jueves", "Viernes", "Sábado", "Domingo"];
const pad = (n) => String(n).padStart(2, "0");
export const isoDate = (d) => `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`;
export const todayIso = () => isoDate(new Date());
export const longDate = (iso) => { const [y, m, d] = iso.split("-").map(Number); return new Date(y, m - 1, d).toLocaleDateString("es-ES", { weekday: "long", day: "numeric", month: "long" }); };
export const googleCalUrl = (a, other) => {
  const f = (t) => `${a.date.replaceAll("-", "")}T${t.replace(":", "")}00`;
  const q = new URLSearchParams({ action: "TEMPLATE", text: `HandyZoom · ${a.job_title ?? "Cita"}`, dates: `${f(a.start)}/${f(a.end ?? a.start)}`, details: other ? `Cita con ${other}` : "" });
  return `https://calendar.google.com/calendar/render?${q.toString()}`;
};
